import { LS } from '@services/ls'
import { _CONST } from '@/constants/constants'
import en from './translates/en.json'
import ru from './translates/ru.json'

type Messages = Record<string, any>

const messages: Record<string, Messages> = {
  en,
  ru,
}

function get(obj: any, path: string): any {
  return path.split('.').reduce((acc: any, key: string) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj)
}

export const useTranslate = () => {
  const locale = (LS.get(_CONST.lsKeys.lang) as string) || 'ru'

  const setLocale = (newLocale: string) => {
    LS.set(_CONST.lsKeys.lang, newLocale)
  }

  const translateFunction = (key: string, params?: Record<string, any>): string => {
    const dict = messages[locale] || messages['ru']
    let val = get(dict, key)
    if (typeof val !== 'string') {
      return key
    }
    if (params) {
      Object.keys(params).forEach(k => {
        val = val.replace(new RegExp('{' + k + '}', 'g'), String(params[k]))
      })
    }
    return val
  }

  return {
    locale,
    setLocale,
    translateFunction
  }
}

export const translateFunction = (key: string, params?: Record<string, any>): string => {
  const translate  = useTranslate()
  return translate.translateFunction(key, params)
}
